var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342.375 1.464L198.375 36.841C185.125 41.092 176 53.343 176 67.344V366.49C157.875 357.364 135.875 351.989 112 351.989C50.125 351.989 0 387.866 0 431.994S50.125 512 112 512S224 476.122 224 431.994V195.353L361.625 161.975C375 157.725 384 145.474 384 131.473V31.966C384 21.715 379.125 12.215 370.875 6.214C362.625 0.089 352.125 -1.536 342.375 1.464ZM112 463.997C72.25 463.997 48 443.245 48 431.994C48 420.744 72.25 399.992 112 399.992S176 420.744 176 431.994C176 443.245 151.75 463.997 112 463.997ZM336 119.722L224 144.974V79.094L336 53.843V119.722Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote);
export default __webpack_public_path__ + "static/media/music-note.df2b65f32ddd8b6537f0f6fb68daa27c.svg";
export { ForwardRef as ReactComponent };